var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/24/intern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.4565127,2.31482249 C11.8246335,1.49395003 13.5841109,1.89074892 14.473759,3.18992265 L14.5724788,3.343814 L21.8574929,15.4855042 C22.1416411,15.9590845 21.988076,16.5733448 21.5144958,16.8574929 C21.0747427,17.1213448 20.5136889,17.0077807 20.2082771,16.6110362 L20.1425071,16.5144958 L12.8574929,4.37280551 C12.5733448,3.89922524 11.9590845,3.74566018 11.4855042,4.02980834 C11.379942,4.09314566 11.2872902,4.17524125 11.2119347,4.27170921 L11.1425071,4.37280551 L2.67488783,18.4855042 C2.39073967,18.9590845 2.54430474,19.5733448 3.017885,19.8574929 C3.13444655,19.9274299 3.26361992,19.9726216 3.3973838,19.9908464 L3.53238076,20 L18.5,20 C19.0522847,20 19.5,20.4477153 19.5,21 C19.5,21.5128358 19.1139598,21.9355072 18.6166211,21.9932723 L18.5,22 L3.53238076,22 C2.98864892,22 2.4551397,21.8522265 1.98889349,21.5724788 C0.620772723,20.7516063 0.142900007,19.0123973 0.870571856,17.6160379 L0.959901981,17.4565127 L9.42752122,3.343814 C9.68087051,2.92156518 10.0342639,2.56817177 10.4565127,2.31482249 Z",
    id: "path-intern"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24/intern",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-intern",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-intern"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Line-3",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-intern"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-intern)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntern);
export default __webpack_public_path__ + "static/media/intern.eaf265fab6e5d83e3a1cd1d0e8196cb0.svg";
export { ForwardRef as ReactComponent };